import { CopyProperties } from 'src/app/shared/decorator/copy-properties.decorator';
import { NumberUtil } from '../../util/number.util';

@CopyProperties()
export class ValueRange {
  beginValue: number;
  beginOperatorCode: string;
  endOperatorCode: string;
  beginVolume: string; 
  endVolume: string; 
  endValue: number;
  keyValue: number;
  fee: number;
  id: number;
  productId: number;
  typeCode: string;
  description: string;
  note: string;
  constructor(
    params?: any
  ) {
    this.beginValue = null;
    this.endValue = null;
    this.keyValue = null;
    this.fee = null;
    this.id = null;
    this.productId = null;
    this.beginOperatorCode = '';
    this.endOperatorCode = '';
    this.beginVolume = params.beginValue;
    this.endVolume = params.endValue;
    this.typeCode = '';
    this.note = '';
    this.description = '';
  }
}
